import React, { useState, useEffect, useContext } from 'react';
import ProjectCategoryService from "../../controller/ProjectCategoryController/ProjectCategoryController";
import ProjectService from "../../controller/ProjectController/ProjectController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CreateProjectCategory from './CreateProjectCategory';
import HelpSite from "../../../Common/HelpLink";
import Cookies from "js-cookie";
function ProjecCategoryListPage() {
    const navigate = useNavigate();
    const [projectCategoryList, setProjectCategory] = useState([]);
    const { theme } = useContext(ThemeContext);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [modalInstance, setModalInstance] = useState(null);
    const [ProjectList, setProjects] = useState([]);
    const [currentProjectCategory, setCurrentProjectCategory] = useState(null);
    const [selectedProject, setSelectedProject] = useState(0);

    const [currentPage, setCurrentPage] = useState(1); // Current page
    const UserID = localStorage.getItem("UserID");
    const CompanyID = localStorage.getItem("CompanyID");

    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const setSortConfigInCookie = (config) => {
        Cookies.set(`projectCategorySort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`projectCategorySort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };

    useEffect(() => {
        fetchProjects();
        fetchProjectCategory(0, currentPage, pageSize);

    }, [currentPage, pageSize]);
    useEffect(() => {
        fetchProjects();
        fetchProjectCategory(0, currentPage, pageSize);

    }, [sortConfig]);



    useEffect(() => {
        setModalInstance(new window.bootstrap.Modal(document.getElementById('projectCategoryModal')));
    }, []);

    const fetchProjectCategory = async (ProjectID = 0, page, size) => {
        try {
            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();
            const list = await ProjectCategoryService.GetAllProjectCategories(ProjectID, redirectCallback, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
            setProjectCategory(list);
        } catch (error) {
            console.error('Error fetching Project Categories:', error);
        }
    };

    const fetchProjects = async () => {
        try {
            const list = await ProjectService.GetAllProjects(redirectCallback, "1", "1000",
                "", sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
            setProjects(list);
        } catch (error) {
            console.error('Error fetching Projects:', error);
        }
    };

    const handleCreateProjectCategoryClick = async () => {
        setCurrentProjectCategory(null);
        await fetchProjects();
        setSelectedProject(0);
        handleProjectChange({ target: { value: 0 } });
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleCloseModal = () => {
        if (modalInstance) {
            modalInstance.hide();
        }
    };

    const handleEditClick = async (category) => {
        await fetchProjects();
        setCurrentProjectCategory(category); // Set the project category to be edited
        setSelectedProject(0);
        handleProjectChange({ target: { value: 0 } });
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleDeleteClick = async (ID) => {
        const confirmed = window.confirm("Are you sure you want to delete this project category?");
        if (confirmed) {
            try {
                await ProjectCategoryService.DeleteProjectCategory(ID); // Ensure this matches the actual function name in your service
                await fetchProjectCategory(0, "0", pageSize); // Fetch the updated list of project categories
            } catch (error) {
                console.error('Error deleting project category:', error);
            }
        }
    };

    const handleProjectChange = (event) => {
        const { value } = event.target;
        setSelectedProject(value);
        fetchProjectCategory(value, "0", pageSize);
    };

    const handleProjectClick = () => {
        fetchProjects();
    };

    const handleFormSuccess = async () => {
        await fetchProjectCategory(selectedProject, "0", pageSize);
        handleProjectChange({ target: { value: selectedProject } });
    };
    const handleProjectCategoryToggle = async (ProjectID, ProjectCategoriesID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            setProjectCategory([]);
            await ProjectCategoryService.SetDefaultProjectCategory(ProjectCategoriesID, ProjectID);
            await fetchProjectCategory(0, "0", pageSize);
            await fetchProjects();

        } catch (error) {
            console.error('API request failed:', error);
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');

    const defaultColumns = [
        "ProjectName",
        "CategoryName",
        "ProjectDescription"
    ];
    const defaultColumnsForSearch = [
        "ProjectName",
        "CategoryName",
        "ProjectDescription"

    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnOptions = [
        { value: "ProjectName", label: "ProjectName" },
        { value: "CategoryName", label: "CategoryName" }

    ];
    const columnSearchOptions = [
        { value: "ProjectName", label: "ProjectName" },
        { value: "CategoryName", label: "CategoryName" }


    ];
    const handleSearchColumnChange = (selectedOptions) => {
        setSearchColumns(selectedOptions);

    };
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`projectCategoryColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`projectCategoryColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };

    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page


        let columnsToSearch = searchColumns.length > 0
            ? searchColumns.join(",")
            : "ALL";

        setSearchOptions(columnsToSearch);
        const query = searchQuery.toLowerCase(); // Use current searchQuery state

        const locationData = await ProjectCategoryService.GetAllProjectCategories(selectedProject, redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setProjectCategory(locationData);

    };
    const handleSort = async (key) => {

        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);
        //   const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });
        const query = searchQuery.toLowerCase();
        const locationData = await ProjectCategoryService.GetAllProjectCategories(selectedProject, redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setProjectCategory(locationData);

    };
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-3">
                    <button className='btn btn-primary btn-sm' onClick={handleCreateProjectCategoryClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Project Categories" Module="26" />
                </div>
            </div>
            <div className="row mb-3">
                <label htmlFor="ProjectID" className="col-sm-2 col-form-label">Select Project:</label>
                <div className="col-sm-4">
                    <select name="ProjectID" className='form-control' value={selectedProject} onChange={handleProjectChange} onClick={handleProjectClick}>
                        <option value="0">--Select--</option>
                        {ProjectList.map((project) => (
                            <option key={project.ID} value={project.ID}>
                                {project.ProjectName}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="row mb-3">

                <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                    </select>
                </div>
                <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                <div className="col-sm-6"></div>
                <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>


                </div>
                <div className="col-sm-2 d-flex justify-content-end">
                    <input
                        list="recent-searches"
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="form-control me-2"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSearchButtonClick();
                            }
                        }}
                    />

                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                        <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                </div>


            </div>
            <table className="table m-0 table-hover">
                <thead>
                    <tr>
                        <th onClick={() => handleSort('ProjectName')}>Project Name</th>
                        <th onClick={() => handleSort('CategoryName')}>Category</th>
                        <th>Default</th>
                        <th style={{ "textAlign": "right" }}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {projectCategoryList.map((category, index) => (
                        <tr key={category.ProjectCategoriesID} onClick={() => handleEditClick(category)}>
                            <td>{category.ProjectName}</td>
                            <td>{category.CategoryName}</td>
                            <td>
                                <button style={{ "padding": "4px 5px" }}
                                    className={`btn ${category.IsDefault === 1 ? 'btn btn-success btn-sm' : 'btn btn-secondary btn-sm'}`}
                                    onClick={() => handleProjectCategoryToggle(category.ProjectID, category.ProjectCategoriesID)}
                                >
                                    {category.IsDefault === 1 ? 'On' : 'Off'}
                                </button>
                            </td>
                            <td style={{ "textAlign": "right" }}>

                                <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleDeleteClick(category.ProjectCategoriesID)}>
                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <CreateProjectCategory
                category={currentProjectCategory}
                onClose={handleCloseModal}
                onSuccess={handleFormSuccess}
                ProjectList={ProjectList}
            />
        </div>
    );
}

export default ProjecCategoryListPage;
